﻿import { peek } from "./overview-filters";
import { setBadges } from "./overview-filter-badge";
import {
	deleteSearchParam,
	getSearchParams,
	numberFilters,
	setSearchParam,
	valueFilters,
} from "./overview-filter-state";
import { attributes } from "./overview-filter-constants";

const findValueInput = (filter) => {
	return document.querySelector(
		`[${attributes.filterValue}][${attributes.filterName}=${filter}]`
	);
};

const findValueResetButton = (filter) => {
	return document.querySelector(`[${attributes.filterValueReset}=${filter}]`);
};

const findValueResetButtons = () => {
	return document.querySelectorAll(`[${attributes.filterValueReset}]`);
};

const bindResetTriggers = (filter) => {
	const button = findValueResetButton(filter);

	if (button)
		button.addEventListener(
			"click",
			async () =>
			{
				const input = findValueInput(filter);
				await setFilterValue(filter, "", false);
				input.focus();
			}
		);
};

const handleInputButtonsVisibility = (
	resetButton,
	locationButton,
	inputElement
) => {
	if (inputElement.value && inputElement === document.activeElement) {
		resetButton.classList.remove("tw-hidden");
	} else {
		setTimeout(() => { resetButton.classList.add("tw-hidden"); }, 100);
	}

	if(locationButton)
	{
		if(inputElement.value)
			locationButton.classList.add("tw-hidden");
		else
			locationButton.classList.remove("tw-hidden");
	}
};

const validateHours = () => {
	const minValueInput = findValueInput(numberFilters.minHours);
	const maxValueInput = findValueInput(numberFilters.maxHours);
	validateValue(minValueInput);
	validateValue(maxValueInput);

	let minValue = Number.parseInt(minValueInput.value);
	let maxValue = Number.parseInt(maxValueInput.value);
	const minValueValid = typeof minValue === "number" && isFinite(minValue);
	const maxValueValid = typeof maxValue === "number" && isFinite(maxValue);

	if(minValueValid && !maxValueValid)
		maxValue = maxValueInput.max;
	else if (!minValueValid && maxValueValid)
		minValue = minValueInput.min;

	// Minimum > Maximum
	if (minValue > maxValue) {
		const tempMaxValue = maxValue;
		maxValue = minValue;
		minValue = tempMaxValue;
	}

	minValueInput.value = minValue;
	maxValueInput.value = maxValue;
};

const validateValue = (input) => {
	if (!input.checkValidity()) {
		if (input.type === "number" && input.value > input.max)
			input.value = input.max;
		else if (input.type === "number" && input.value < input.min)
			input.value = input.min;
	}
};

export const clearNumberInputs = () => {
	for (const filter in numberFilters) {
		const numberInput = findValueInput(numberFilters[filter]);
		numberInput.value = undefined;
	}
};

export const bindValueGroup = (filter) => {
	bindResetTriggers(filter);
};

export const bindResetButtonsVisibility = () => {
	const resetButtons = findValueResetButtons();
	resetButtons.forEach((resetButton) => {
		const resetTarget = resetButton.dataset.filterResetTarget;
		const inputElement = document.querySelector(
			`[data-filter-name="${resetTarget}"]`
		);
		const locationButton = document.querySelector(
			`[data-filter-geo-target="${resetTarget}"]`
		);

		["input", "change", "focusin", "focusout"].forEach(eventName => {
			inputElement.addEventListener(eventName, () =>
				handleInputButtonsVisibility(
					resetButton,
					locationButton,
					inputElement
				)
			);
		});

		handleInputButtonsVisibility(resetButton, locationButton, inputElement);
	});
};

export const setFilterValue = async (filter, value) => {
	const input = findValueInput(filter);
	input.value = value;

	const event = new Event("change");
	input.dispatchEvent(event);
};

export const saveFilterValues = () => {
	const searchTermValue = findValueInput(valueFilters.searchTerm).value;
	if (searchTermValue)
		setSearchParam(valueFilters.searchTerm, searchTermValue);

	else deleteSearchParam(valueFilters.searchTerm);

	const location = findValueInput(valueFilters.location).value;
	const radius = findValueInput(valueFilters.radius).value;

	if (location && radius) {
		setSearchParam(valueFilters.location, location);
		setSearchParam(valueFilters.radius, radius);
	} else {
		deleteSearchParam(valueFilters.location);
		deleteSearchParam(valueFilters.radius);
	}
};

export const bindHoursRefresh = () => {
	for (const filter in numberFilters) {
		const input = findValueInput(numberFilters[filter]);
		input.addEventListener("change", async () => {
			validateHours();
			paramsFromNumbers(numberFilters.minHours, numberFilters.maxHours);

			updateHoursBadge();
			await peek();
		});
	}
};

export const updateHoursBadge = () => {
	setBadges(
		"Hours",
		anyHourFilters()
	);
};

export const anyHourFilters = () => {
	const params = getSearchParams();
	const minHours = params.get(numberFilters.minHours);
	const maxHours = params.get(numberFilters.maxHours);

	return (minHours != null && minHours !== "0") ||
		(maxHours != null && maxHours !== "40");
}

const paramsFromNumbers = (...filters) => {
	if (filters.every((filter) => findValueInput(filter)?.value)) {
		filters.forEach((filter) => {
			const value = findValueInput(filter).value;
			setSearchParam(filter, value);
		});
	} else {
		filters.forEach((filter) => deleteSearchParam(filter));
	}
};

export const setSearchFieldsFromParams = () => {
	const params = getSearchParams();
	for (const filter in valueFilters) {
		const input = findValueInput(valueFilters[filter]);
		if (params.has(valueFilters[filter])) {
			input.value = params.get(valueFilters[filter]);
		} else {
			input.value = "";
		}
	}
};

export const setNumbersFromParams = () => {
	const params = getSearchParams();
	for (const filter in numberFilters) {
		const input = findValueInput(numberFilters[filter]);
		if (params.has(numberFilters[filter])) {
			input.value = params.get(numberFilters[filter]);
		}
	}
};
